import React, { useState, useEffect } from 'react';
import style from './notification.module.css';
import nopic from '../../img/no_photo_neutral.svg';
import Header from '../header/header';

function Notification() {
    const [notifications, setNotifications] = useState([]);

    const addNotification = (newNotification) => {
        setNotifications(prevNotifications => {
            if (prevNotifications.length >= 3) {
                const updatedNotifications = prevNotifications.slice(1);
                return [...updatedNotifications, newNotification];
            } else {
                return [...prevNotifications, newNotification];
            }
        });
    };
    const ClickNotifiction = (type) => {
        switch (type) {
          case 'like':
              Header.OpenLike();
              setNotifications([]);
              break;
          case 'submitlike':
              Header.OpenLove();
              setNotifications([]);
              break;
          case 'message':
                Header.setPage(2);
                setNotifications([]);
              break;
          default:
             
              break;
        }

    };

    Notification.addNotification = addNotification; // Добавляем функцию как статический метод

    useEffect(() => {
        if (notifications.length > 0) {
            const timer = setTimeout(() => {
                setNotifications(prevNotifications => prevNotifications.slice(1));
            }, 7000);

            return () => clearTimeout(timer);
        }
    }, [notifications]);

    return (
        <div className={style.notification_float}>
            {notifications.map((notification, index) => (
                <div key={index} className={style.notification} onClick={() => ClickNotifiction(notification.type)}>
                    <img src={(notification.image ? `https://winxy.ru/static_img.php?id=${notification.image}` : nopic)} alt='' />
                    <p>{notification.message}</p>
                </div>
            ))}
        </div>
    );
}

export default Notification;